// ── PID: 사용자 (10xxx) ──────────────────────────────────
export const PID_USER_DUP_CHECK = '10001'
export const PID_USER_REGISTER  = '10002'
export const PID_USER_LOGIN     = '10003'
export const PID_USER_LOGOUT    = '10004'
// SEQ=10110 STEP=4 — 내정보 변경
export const PID_USER_UPDATE_NICKNAME = '10010' // 닉네임 변경
export const PID_USER_CHANGE_PASSWORD = '10011' // 비밀번호 변경 + 타 기기 토큰 무효화

// ── PID: 룸 (11xxx) — Phase 1 ────────────────────────────
// SignalR 전용: 11001(ROOM_CREATE) / 11002(ROOM_JOIN) / 11003(ROOM_LEAVE)
//              11006(HOST_TRANSFER) / 11010(OPTIONS_UPDATE) / 11020(ROOM_START)
export const PID_ROOM_LIST   = '11004' // REST POST — 공개 룸 리스트
export const PID_ROOM_DETAIL = '11005' // REST POST — 룸 단건 조회
export const PID_ROOM_MY     = '11007' // REST POST — 내 룸 조회 (자동 복귀용, Phase 1.5)

// ── PID: 채팅 (13xxx) — SignalR 전용 ─────────────────────
export const PID_ROOM_CHAT_SEND = '13001' // SignalR RoomHub.SendChat (REST 미노출)

// ── PID: 카탄 (20xxx) — Phase 2 ──────────────────────────
export const PID_CATAN_GAME_STATE = '20101' // REST POST — 보드 + 게임 상태 통합 조회

// ── PID: 티켓 투 라이드 (21xxx) — SEQ=10147 운영 가동 ────
export const PID_TTR_GAME_STATE = '21101' // REST POST — TTR 보드 + 게임 상태 통합 조회

// ── PID: 루미큐브 (22xxx) — SEQ=10220 신설 ───────────────
export const PID_RUMK_GAME_STATE = '22001' // REST POST — 루미큐브 게임 상태 통합 조회 (sp_RummikubGameSnapshot)

// ── PID: 친구 (17xxx) — P-Track 0 ────────────────────────
export const PID_FRIEND_LIST    = '17001' // REST — 내 친구 목록
export const PID_FRIEND_REQUEST = '17002' // REST — 친구 요청 보내기
export const PID_FRIEND_RESPOND = '17003' // REST — 수락/거부
export const PID_FRIEND_DELETE  = '17004' // REST — 친구 삭제
export const PID_FRIEND_BLOCK   = '17005' // REST — 차단/해제
export const PID_FRIEND_SEARCH  = '17006' // REST — 닉네임 검색

// ── PID 카테고리 (Phase 1+ 예약) ────────────────────────
// 12xxx MATCH (MATCH_QUEUE / MATCH_QUICK)
// 14xxx PROFILE / RANK
// 99xxx ADMIN

// ── 응답 코드 ────────────────────────────────────────────
export const RET_OK           = '00'
export const RET_FORCE_LOGOUT = '97'
export const RET_USER_ERROR   = '98'
export const RET_SYS_ERROR    = '99'

// ── 파라미터 구분자 ──────────────────────────────────────
export const DELIM = '\x18'
